<div class="info-icon" [class.error]="error" #infoTrigger>i</div>
<ng-template #cdkPortal>
  <div class="infoWindow" #infoWindow>
    <div class="infoArrow" [class.errorArrow]="error" #infoArrow></div>
    <div class="wrapper" [class.error]="error" #infoWrapper>
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>
